import { render, staticRenderFns } from "./VizModeBoxPlot.vue?vue&type=template&id=5848bc30&scoped=true&"
import script from "./VizModeBoxPlot.vue?vue&type=script&lang=js&"
export * from "./VizModeBoxPlot.vue?vue&type=script&lang=js&"
import style0 from "./VizModeBoxPlot.vue?vue&type=style&index=0&id=5848bc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848bc30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
